import "react-app-polyfill/ie9"; // For IE 11 support
import "react-app-polyfill/stable";
import "current-script-polyfill";
import("./bootstrap");
